import {
  createLineByLineMessage,
  createTypewriterMessage,
  createProgressMessage,
} from '../utils/messages';
import type { Message } from '../types';

export const COMMANDS = {
  help: {
    // thinking: 'Analyzing available commands',
    response: createLineByLineMessage(
      `Sure! Here are the available commands:

• help        - Show this help message
• demo        - See MIFTA in action
• install     - Installation instructions
• features    - List all features
• deploy      - Deploy your automation
• docs        - View documentation
• about       - About MIFTA
• clear       - Clear terminal

Type any command to get started!`,
      10
    ),
  },
  demo: {
    thinking: 'Loading demo environment',
    response: createLineByLineMessage(
      `Awesome! Let me show you what MIFTA can do:

✓ Automated deployment pipelines
✓ Smart documentation generation
✓ Workflow orchestration
✓ Integration with popular tools
✓ Custom script automation

MIFTA saves you hours every week by automating repetitive tasks.
Would you like to try 'features' or 'install'?`,
      200
    ),
  },
  install: {
    thinking: 'Preparing installation guide',
    response: createLineByLineMessage(
      `Perfect! Here's how to get started:

npm install -g mifta

Or with yarn:
yarn global add mifta

Then initialize your project:
mifta init

That's it! You're ready to automate. Type 'docs' for more info.`,
      250
    ),
  },
  features: {
    thinking: 'Compiling feature list',
    response: createLineByLineMessage(
      `Great question! Here's what MIFTA offers:

🚀 Quick Automation
   Set up workflows in minutes, not hours

⚡ Smart Triggers
   Automated responses to events

📝 Auto Documentation
   Generate docs from your code

🔄 CI/CD Integration
   Seamless deployment pipelines

🎯 Task Dependencies
   Manage complex workflows easily

Type 'deploy' to learn about deployment options.`,
      200
    ),
  },
  deploy: {
    thinking: 'Checking deployment options',
    response: createProgressMessage(
      `Excellent choice! MIFTA supports multiple deployment strategies:

• Automatic deployments on git push
• Scheduled deployments (cron-style)
• Manual trigger with approval workflows
• Rollback capabilities
• Multi-environment support

Run: mifta deploy --help for detailed options.`,
      [
        { label: 'Checking deployment options', duration: 800 },
        { label: 'Loading strategies', duration: 1000 },
        { label: 'Ready', duration: 500 },
      ]
    ),
  },
  docs: {
    thinking: 'Fetching documentation',
    response: createLineByLineMessage(
      `Of course! Documentation is available at:

📚 docs.mifta.dev

Quick links:
• Getting Started Guide
• API Reference
• Examples & Tutorials
• Best Practices
• Community Forum

You can also run 'mifta docs' locally to browse offline.`,
      250
    ),
  },
  about: {
    thinking: 'Loading about information',
    response: createTypewriterMessage(
      `MIFTA - Make It Fast Through Automation

Version: 1.0.2
Built with ❤ for developers who value their time

Our mission: Eliminate repetitive tasks and let you focus on
what truly matters - building great products.

Follow us: @mifta.dev`,
      30
    ),
  },
} as const;

export type CommandKey = keyof typeof COMMANDS;

export interface CommandDefinition {
  thinking: string;
  response: Message | string;
}
